import { addStyles } from 'ethcss'
import { colors, indents, IStyles, mediaCSS } from 'theme'

export const styles: IStyles = {
    distributives: {
        padding: `0!important`,
    },
    distributives__wrapper: {
        overflow: 'auto',
    },
    distributives__wrapper__withPadding: {
        overflow: 'auto',
        paddingTop: 50,
    },
    distributives__content: {
        padding: '40px 30px',
    },
    distributives__platform: {
        paddingBottom: indents.mini,
        borderRadius: '10px',
    },
    tabs: {
        padding: '0 30px',
        display: 'flex',

        [mediaCSS.tabMini]: {
            overflow: 'auto',
            padding: '8px 30px',
        },
    },
    tab: {
        padding: '12px 42px',
        border: `1px solid var(--var-module-app-component-app-style-border, ${colors.greyLight})`,
        borderRadius: 10,
        marginRight: 16,
        cursor: 'pointer',
        background: `var(--var-module-app-component-content-style-background, ${colors.white})`,
    },
    tabActive: {
        background: `var(--var-module-app-component-app-style-active, ${colors.blueAccent})`,
        color: colors.white,
    },
    panel: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 20,
        border: `1px solid var(--var-module-app-component-app-style-border, ${colors.greyLight})`,
        backgroundColor: `var(--var-module-app-component-content-style-background, ${colors.white})`,
        borderRadius: '10px 10px 0 0',
        marginBottom: '-7px',
    },
    selectAll: {
        display: 'flex',
        alignItems: 'center',
    },
    selectAllLabel: {
        marginLeft: 10,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 15px',
        width: 100,
    },
    confirmModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: colors.modalBackground,
        zIndex: 10000,
    },
    confirmModalInner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        background: `var(--var-module-app-component-content-style-background, ${colors.white})`,
        borderRadius: 10,
        padding: 30,
    },
    confirmModalCaption: {
        textAlign: 'center',
        marginBottom: 30,
    },
    topPadding: {
        paddingTop: 50,
    },
}

addStyles(styles)
